<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-non-bodymatter element-container-single element-type-preface element-with-heading" epub:type="preface" id="preface-2" role="doc-preface">
<div class="heading heading-with-title heading-without-image" id="preface-2-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">I Am the World</h1>
</div>
</div>
</div>
</div>
<div class="text" id="preface-2-text">
<p class="first first-in-chapter first-full-width">I cannot argue with pro-self. It either permits or doesn’t. I can, it says, kill any <i>mayfly </i>that endangers the success of the mission, but I cannot do away with them on the grounds that they annoy me.</p>
<p class="subsq">“If they attack me, may I term them all?”</p>
<p class="subsq">“Only as many as you must to keep them from damaging us permanently.”</p>
<p class="subsq">I think of something else. “Am I required to maintain any certain standard of living?”</p>
<p class="subsq">“No.”</p>
<p class="subsq">It occurs to me that I am eager for these <i>mayfly-humans </i>to do something very, very stupid.</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// iamtheworld.vue?432651ae